'use client';

import { c as _c } from "react/compiler-runtime";
import { Chip } from '@sprd/sprd-component-kit/v2';
import React from 'react';
import { DesignProductFilter } from '@/app/[abTest]/[locale]/(spreadshirt)/shop/design/utility/recommendations';
import { tracker } from '@/utility/tracking/tracker';
type DesignSimilarProductsFiltersProps = {
  designProductFilters: DesignProductFilter[];
  activeFilter: DesignProductFilter | undefined;
  onActiveFilterChange: (filter: DesignProductFilter) => void;
};
export const SimilarProductsFilters = t0 => {
  const $ = _c(14);
  const {
    designProductFilters,
    activeFilter,
    onActiveFilterChange
  } = t0;
  let t1;
  if ($[0] !== activeFilter) {
    t1 = t2 => {
      const {
        id
      } = t2;
      return activeFilter && activeFilter.id === id;
    };
    $[0] = activeFilter;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isSelected = t1;
  let t2;
  if ($[2] !== isSelected || $[3] !== onActiveFilterChange) {
    t2 = filter => {
      if (isSelected(filter)) {
        return;
      }
      tracker.trackFeature({
        featureUsed: "similar-products-filter",
        detail: {
          id: filter.id,
          name: filter.name
        }
      });
      onActiveFilterChange(filter);
    };
    $[2] = isSelected;
    $[3] = onActiveFilterChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const toggleFilter = t2;
  let t3;
  if ($[5] !== designProductFilters || $[6] !== isSelected || $[7] !== toggleFilter) {
    let t4;
    if ($[9] !== isSelected || $[10] !== toggleFilter) {
      t4 = filter_0 => <Chip key={filter_0.id} selected={isSelected(filter_0)} variant="secondary" className="mr-2 whitespace-nowrap" onClick={() => toggleFilter(filter_0)}>{filter_0.name}</Chip>;
      $[9] = isSelected;
      $[10] = toggleFilter;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = designProductFilters.map(t4);
    $[5] = designProductFilters;
    $[6] = isSelected;
    $[7] = toggleFilter;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[12] !== t3) {
    t4 = <div className="flex overflow-x-auto scroll-smooth px-4 no-scrollbar sm:px-6 md:px-8 lg:px-16 xl:px-22.5">{t3}</div>;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};